export const fromServicesSlugToUrl = slug => `/${slug}/`;

export const fromBlogSlugToUrl = slug => `/blog/${slug}/`;

export const fromArticleSlugToUrl = slug => `/blog/${slug}/`;



